<template>
  <div>
    <div class="header">
      <site-topbar></site-topbar>
      <site-header></site-header>
      <site-category></site-category>
    </div>
    <page-main></page-main>
    <site-footer></site-footer>
    <site-info></site-info>
  </div>
</template>
<script>
import SiteTopbar from "../Layout/SiteTopbar.vue";
import SiteHeader from "../Layout/SiteHeader.vue";
import SiteFooter from "../Layout/SiteFooter.vue";
import SiteInfo from "../Layout/SiteInfo.vue";
import PageMain from "./PageMain.vue";
import SiteCategory from "./SiteCategory.vue";

export default {
  components: {
    "site-topbar": SiteTopbar,
    "site-header": SiteHeader,
    "page-main": PageMain,
    "site-footer": SiteFooter,
    "site-info": SiteInfo,
    "site-category": SiteCategory,
  },
  name: "Home",
  mounted() {},
};
</script>
<style>
@import "../../assets/css/search.css";
.site-header .nav-category .link-category{
  visibility:visible!important;
}
.category-item > a{
  color:#555!important;
}
.site-category-list{
  box-sizing: border-box;
  height: 460px!important;
  border:1px solid #ccc;
}
</style>
